import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import CustomButtonLink from "../buttonComponent";
import parse from "html-react-parser"

const Section1 = ({ data }) => {
  let [width, setwidth] = useState(window.innerWidth);
  const editRef = useRef();

  useEffect(() => {
    if (editRef.current) {
      const height = editRef.current.offsetHeight;
      document.documentElement.style.setProperty("--edit-height", `${height / 3.5}px`);
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setwidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="w-full flex justify-center bg-Darkblue products">
      <div className="2xl:container w-full mt-12 sm:mt-16 md:px-10 lg:px-20  px-6 flex justify-center lg:mt-[72px]">
        <div className={`flex flex-col w-full gap-10 sm:gap-20 items-center justify-center`}>
          <div className={`w-full lg:w-[90%]   gap-3 flex flex-col items-center text-center  `} >
            <div className="flex gap-2 items-center">
              <img src={process.env.PUBLIC_URL + '/images/content/Star.svg'} alt="icon" />
              <h4 className="text-16 md:text-18 text-orangeyellow font-medium">{data.Section1.Title ? data.Section1.Title.toUpperCase() : ""}</h4>
            </div>
            <h1 className="text-24 z-[2] sm:text-32 mt-1 lg:text-48 text-white font-bold"> {data.Section1.Heading}</h1>
            <p className="text-14 z-[2] sm:text-16  lg:text-18 text-lightwhite w-full sm:w-[90%]">
              {parse(data.Section1.desc)}
            </p>
            <div className="flex items-center gap-4 pt-3 sm:pt-5 sm:pb-6">
              <CustomButtonLink to={"/company/contactus"} label={"Explore The Platform"} />
              {
                data.Section1.href ? (
                  <Link
                    to={data.Section1.href} target="_"
                    className="py-[10px] lg:py-[11px] px-[18px] sm:px-5  bg-transparent text-highlight hover:bg-btnhover hover:text-white  border-[1px] border-ctaorange rounded-[12px] sm:rounded-[16px]"
                  >
                    <p className="sm:text-base text-12 font-semibold ">
                      Visit Live Site
                    </p>
                  </Link>) : <></>}
            </div>

          </div>
          {
            data.Section1.img && !data.Section2 ?
              <div className="w-full">
                <img className="w-full" src={process.env.PUBLIC_URL + (width < 769 && data.Section1.mobilebg ? data.Section1.mobilebg : data.Section1.img)} alt='img' />
              </div>
              : data.Section1.img1 ? <div className="flex gap-x-4 gap-y-10 w-full max-md:flex-col max-md:items-center max-md:w-full">
                <img
                  className='md:w-[30%] sm:w-[70%] w-[80%]'
                  src={process.env.PUBLIC_URL + "/images/Allproducts/xpertxpress/header-img1.png"}
                  alt="banner_img"
                />
                <img className='w-[70%] h-fit max-md:w-full'
                  src={process.env.PUBLIC_URL + "/images/Allproducts/xpertxpress/header-img2.png"}
                  alt="banner_img"
                />
              </div> : <></>
          }
          {data.Section2 ?
            <div className=" w-full flex flex-col justify-center lg:flex-row gap-10 lg:gap-20 pb-12 sm:pb-16 lg:pb-[72px]">
              <div className="w-full lg:w-1/2 ">
                <img
                  className="w-full"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Allproducts/editlatex/editlatex.png"
                  }
                  alt="editlatex_img"
                />
              </div>
              <div className="w-full lg:w-1/2 flex flex-col text-white">
                <h2 className="text-20 md:text-32 lg:text-40 font-semibold">
                  {data.Section2.Title}
                </h2>
                <p className="mt-2 font-regular text-lightwhite text-14 sm:text-16 md:text-18   ">
                  {data.Section2.Subtitle}
                </p>
                <div ref={editRef} className="mt-8 md:mt-12 flex flex-col gap-12 ">
                  {data.Section2.Features.map((ft, i) => (
                    <div
                      key={i}
                      className={`flex items-center gap-6 dottedparent `}
                    >
                      <div className="min-h-10 max-h-10 max-w-10 min-w-10 dottedline relative">
                        <img
                          className="h-full w-full"
                          src={process.env.PUBLIC_URL + ft.No}
                          alt={`${i}_img`}
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <h2 className="text-18 md:text-22 font-medium text-orangeyellow">
                          {ft.Title}
                        </h2>
                        <p className="text-lightwhite text-14 sm:text-16 md:text-18 font-regular">{ft.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            : <></>

          }

        </div>
      </div>

    </div>
  );
};

export default Section1;
